import React, { Component, createRef, Fragment } from 'react';
import {connect} from 'react-redux';

import ScheduleContainer from './schedule';
// import ScheduleContainer from '/static/site/test.html';
import SearchContainer from './search';
import FileContainer from './file';
import Division from './division';
import DownloadLog from './downloadlog';
import Setting from './setting';

class ContentContainer extends Component {
  constructor(props){
    super(props);
    this.menuSchedule = 'SCHEDULE';
    this.menuSearch = 'SEARCH';
    this.menuFile = 'FILE';
    this.menuLog = 'DOWNLOADLOG';
    this.menuSetting = 'SETTING';
    this.menuDivision = 'DIVISION';
    this.schedule = createRef();
  }
  componentDidMount(){
  }
  render() {
    const {selectedMenu} = this.props;
    return (
      <Fragment>
        <ScheduleContainer display={selectedMenu === this.menuSchedule} key='SCHEDULE'/>
        {/* <iframe id="schedule" src={process.env.PUBLIC_URL + "/static/site/test.html"} ref={i => this.schedule = i} width="100%" height="700px">
        </iframe> */}
        <SearchContainer display={selectedMenu === this.menuSearch} key='SEARCH' />
        <FileContainer display={selectedMenu === this.menuFile} key='FILE' />
        <Division display={selectedMenu === this.menuDivision} key='DIVISION' />
        <DownloadLog display={selectedMenu === this.menuLog} key='DOWNLOADLOG' />
        <Setting display={selectedMenu === this.menuSetting} key='SETTING' />
      </Fragment>
    )
    
  }
}


const mapStateToProps = (state) => {
  return {
    selectedMenu: state.selectedMenu
  }
};
ContentContainer = connect(mapStateToProps)(ContentContainer);


export default ContentContainer;


// WEBPACK FOOTER //
// ./src/containers/ContentContainer.js